import { render, staticRenderFns } from "./SelectJingdongModal.vue?vue&type=template&id=2b3d6f44&scoped=true&"
import script from "./SelectJingdongModal.vue?vue&type=script&lang=js&"
export * from "./SelectJingdongModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d6f44",
  null
  
)

export default component.exports